import { render, staticRenderFns } from "./mint-dialog.vue?vue&type=template&id=130256e0&scoped=true&"
import script from "./mint-dialog.vue?vue&type=script&lang=ts&"
export * from "./mint-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./mint-dialog.vue?vue&type=style&index=0&id=130256e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130256e0",
  null
  
)

export default component.exports